import { useState } from "react";
import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Panel } from "@/components/AppShell";
import { shortDate, STATS, STAT_LABEL } from "@/lib/format";

export function GameChart({ chart }) {
  const [stat, setStat] = useState("pts");
  const rows = chart.map((c) => ({ ...c, label: `${shortDate(c.date)} ${c.home ? "vs" : "@"}${c.opp}` }));
  return (
    <Panel className="p-5 sm:p-6" data-testid="player-chart">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <h2 className="font-display text-2xl font-bold uppercase">Last {chart.length} games</h2>
        <div className="ml-auto flex gap-1">
          {STATS.map((s) => (
            <button key={s} data-testid={`chart-stat-${s}`} onClick={() => setStat(s)}
              className={`px-2.5 py-1 rounded text-xs font-bold transition-colors ${stat === s ? "bg-blue-600 text-white" : "bg-slate-800 text-slate-400 hover:text-slate-100"}`}>
              {STAT_LABEL[s]}
            </button>
          ))}
        </div>
      </div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={rows} margin={{ left: -18, right: 8, top: 8 }}>
            <CartesianGrid stroke="#2A354B" strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="label" tick={{ fill: "#64748B", fontSize: 10 }} interval="preserveStartEnd" />
            <YAxis tick={{ fill: "#64748B", fontSize: 11 }} />
            <Tooltip contentStyle={{ background: "#121722", border: "1px solid #2A354B", borderRadius: 8 }} labelStyle={{ color: "#F8FAFC" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey={stat} name="Actual" fill="#2563EB" radius={[3, 3, 0, 0]} maxBarSize={22} />
            <Line dataKey={`proj_${stat}`} name="Pre-game projection" stroke="#10B981" strokeWidth={2} dot={{ r: 2 }} connectNulls />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <p className="text-xs text-slate-500 mt-2">Projection line uses the saved morning snapshot when available, otherwise a backtest from games before that date.</p>
    </Panel>
  );
}
